module.exports = __webpack_public_path__ + "static/media/contactsPurple.3e3ba454.svg";